import { useContentfulConfigs } from '@vfmfe/foundations';
import { FooterModelTypeFields } from '@vfpt/common-fe-utils';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from '../modules/store';
import { getFooter } from '../queries';

export function useFooter({ name }: { name: string }) {
    const [footerData, setFooterData] = useState<FooterModelTypeFields | null>(null);
    const [loading, setLoading] = useState(true);

    const contentfulConfigs = useContentfulConfigs({
        journey: 'digital-journey',
        contentfulConfiguration: { applicationId: 'Digital' }
    });
    const currentLanguage = useSelector((state) => state.shell.currentLanguage);

    const configRef = useRef(contentfulConfigs);

    useEffect(() => {
        configRef.current = contentfulConfigs;
    }, [contentfulConfigs]);

    useEffect(() => {
        const fetchFooterData = async () => {
            try {
                setLoading(true);
                const data = await getFooter({ locale: currentLanguage, config: configRef.current, name });
                setFooterData(data);
            } catch (error) {
                console.error('Failed to fetch footer:', error);
                setFooterData(null);
            } finally {
                setLoading(false);
            }
        };

        if (configRef.current) {
            fetchFooterData();
        }
    }, [currentLanguage]);

    return { footerData, loading };
}
